import { Link } from "expo-router";
import { StyleSheet, View } from "react-native";

import { useCartCount } from "@/school-identity/useCartCount";
import { makeStyles } from "@/theme/makeStyles";
import { useTheme } from "@/theme/useTheme";
import { CartIcon } from "@/ui/icons/CartIcon";
import { PressableTarget } from "@/ui/PressableTarget";
import { Text } from "@/ui/Text";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    badge: {
      position: "absolute",
      top: t.space.xxs,
      right: t.space.xxs,
      minWidth: t.size.badge,
      height: t.size.badge,
      paddingHorizontal: t.space.xxs,
      borderRadius: t.radius.pill,
      backgroundColor: t.color.badge,
      alignItems: "center",
      justifyContent: "center",
    },
    badgeText: { color: t.color.badgeText },
  }),
);

/** Cart in the header, linking to /cart (FR-007). The badge shows only when the count is known (009). */
export function CartButton() {
  const theme = useTheme();
  const styles = useStyles();
  const count = useCartCount();
  return (
    <Link href="/cart" asChild>
      <PressableTarget accessibilityRole="link" accessibilityLabel="Cart">
        <CartIcon color={theme.color.text} size={theme.size.icon.md} />
        {typeof count === "number" ? (
          <View style={styles.badge} testID="cart-badge">
            <Text size="xxs" weight="bold" style={styles.badgeText}>
              {String(count)}
            </Text>
          </View>
        ) : null}
      </PressableTarget>
    </Link>
  );
}
